// 개발용 Enum 정의 (자동완성 지원)

const SNT = { // StatisticsNewType

  /// <summary>
  /// 분류 1 : 서비스
  /// </summary>
  A: { // StatisticsNew_ServiceType
    // Service_공통: 100
    // #region Service_공통: 100

    Service_공통__미분류: 100, // 되도록 지양

    // #endregion Service_공통: 100

    // Service_컨텐츠: 200
    // #region Service_컨텐츠: 200

    Service_컨텐츠__복합: 201, // 되도록 지양

    Service_컨텐츠__약품정보: 210,
    Service_컨텐츠__약품정보_라이브DI: 211,

    Service_컨텐츠__메디컬트렌드: 220,

    Service_컨텐츠__설문조사: 230,

    Service_컨텐츠__WeeklyChoice: 240,

    Service_컨텐츠__웹세미나: 250,
    Service_컨텐츠__웹세미나_제약웹세미나: 251,
    Service_컨텐츠__웹세미나_KMA연수교육: 252,

    Service_컨텐츠__공지사항: 260,

    Service_컨텐츠__이벤트: 270,

    Service_컨텐츠__간편처방등록: 280,

    // #endregion Service_컨텐츠: 200

    // Service_인증: 300
    // #region Service_인증: 300

    Service_인증__계정: 310,

    // #endregion Service_인증: 300

    /// / Service_환경: 400
    // //#region Service_환경: 400

    // Service_환경__닥터인포옵션: 410,

    // //#endregion Service_환경: 400

  },

  /// <summary>
  /// 분류 2 : 위치
  /// </summary>
  B: { // StatisticsNew_PositionType
    // [1]App__[8]AppPosition(Form)    :  WebView 없는 경우
    // [1]App__[1]AppPosition(Form)____[1]WebArea____[4]WebComponent__[2]WebComponentPosition(Card)

    // Position_공통: 100000000
    // #region Position_공통: 100000000

    Position_공통__미분류: 100000000, // 되도록 지양

    // #endregion Position_공통: 100000000

    // Position_진료실: 200000000
    // #region Position_진료실: 200000000

    Position_진료실__Background: 210000000,

    Position_진료실__진입: 220000000, // 진료실 App 실행 후 로그인 (잠금해제 로그인은 지원 X) + 진료실 로드 완료

    Position_진료실__닥터인포: 232000000, /// 클릭_내용
    Position_진료실__닥터인포_예외: 232000009, /// 클릭_내용

    /// Position_진료실__라이브뉴스: 240000000,
    // Position_진료실__라이브뉴스_닥터인포: 241000000,     /// 클릭_내용
    Position_진료실__라이브뉴스_라이브DI: 242000000, /// 노출 | 클릭_내용

    /// Position_진료실__의사랑DB: 250000000,
    Position_진료실__의사랑DB_환경설정: 251000000, // 닥터인포 환경설정 ( FOPTION : 약품정보/설문조사/라이브DI/간편처방 )
    Position_진료실__의사랑DB_처방정보: 252000000, // 닥터인포를 통한 간편처방등록 완료

    // #endregion Position_진료실: 200000000

    // Position_닥터인포: 300000000
    // #region Position_닥터인포: 300000000

    /// Position_닥터인포__Background: 310000000      // 닥터인포 App Background
    // #region Position_닥터인포__Background: 310000000

    /// Position_닥터인포__Background_간편처방등록: 311000000,
    Position_닥터인포__Background_간편처방등록: 311000000,

    // #endregion Position_닥터인포__Background: 310000000

    /// Position_닥터인포__메인: 320000000
    // #region Position_닥터인포__메인: 320000000

    /// Position_닥터인포__메인____Background: 321000000,      // 닥터인포 메인 Form 내 Web Background
    Position_닥터인포__메인____Background____토큰_로그인갱신: 321010001,
    Position_닥터인포__메인____Background____토큰_자동갱신: 321010002, // TODO : 소스 검토 후 주석 추가

    /// Position_닥터인포__메인____Header: 322000000,

    /// Position_닥터인포__메인____Header__GNB: 32210000,
    Position_닥터인포__메인____Header____GNB_닥터인포: 322110000,
    Position_닥터인포__메인____Header____GNB_메디컬트렌드: 322120000,
    Position_닥터인포__메인____Header____GNB_약품정보: 322130000,
    Position_닥터인포__메인____Header____GNB_웹심포지엄: 322140000,
    Position_닥터인포__메인____Header____GNB_설문조사: 322150000,
    Position_닥터인포__메인____Header____GNB_이벤트: 322160000,
    Position_닥터인포__메인____Header____GNB_공지사항: 322170000,
    Position_닥터인포__메인____Header____GNB_포인트몰: 322180000,

    /// Position_닥터인포__메인____Header____Account: 322200000,
    Position_닥터인포__메인____Header____Account_로그아웃: 322210000,
    Position_닥터인포__메인____Header____Account_로그인: 322220000,
    Position_닥터인포__메인____Header____Account_마이페이지: 322230000,
    Position_닥터인포__메인____Header____Account_알림: 322240000,
    Position_닥터인포__메인____Header____Account_이번달참여현황: 322250000,
    Position_닥터인포__메인____Header____Account_일대일문의: 322260000,

    /// Position_닥터인포__메인____Body: 323000000,

    /// Position_닥터인포__메인____Body____홈: 323010000
    Position_닥터인포__메인____Body____홈__사용자정보: 323010100,
    Position_닥터인포__메인____Body____홈__사용자정보__로그인: 323010101,
    Position_닥터인포__메인____Body____홈__사용자정보__보유포인트: 323010102,
    Position_닥터인포__메인____Body____홈__사용자정보__설문조사: 323010103,

    /// Position_닥터인포__메인____Body____홈__컨텐츠목록: 323011000,
    // Position_닥터인포__메인____Body____홈__컨텐츠목록_1: 323011100,    // 좌측상 : 약품정보,설문조사
    Position_닥터인포__메인____Body____홈__컨텐츠목록_1__전체: 323011100, // 좌측상 : 약품정보,설문조사
    Position_닥터인포__메인____Body____홈__컨텐츠목록_1__약품정보: 323011101, // 좌측상 : 약품정보,설문조사
    Position_닥터인포__메인____Body____홈__컨텐츠목록_1__설문조사: 323011102, // 좌측상 : 약품정보,설문조사
    // Position_닥터인포__메인____Body____홈__컨텐츠목록_2: 323011200,    // 좌측하 : KMA연수교육
    Position_닥터인포__메인____Body____홈__컨텐츠목록_2_KMA연수교육__컨텐츠목록: 323011201, // 좌측하 : KMA연수교육
    Position_닥터인포__메인____Body____홈__컨텐츠목록_2_KMA연수교육__컨텐츠상세: 323011202, // 좌측하 : KMA연수교육
    // Position_닥터인포__메인____Body____홈__컨텐츠목록_3: 323011300,    // 우측 : 간편처방등록
    Position_닥터인포__메인____Body____홈__컨텐츠목록_3_간편처방등록: 323011301, // 우측 : 간편처방등록
    /// Position_닥터인포__메인____Body____홈__배너: 323012000,
    Position_닥터인포__메인____Body____홈__배너_텍스트_1: 323012110,
    Position_닥터인포__메인____Body____홈__배너_이미지_1: 323012210, // 좌측
    Position_닥터인포__메인____Body____홈__배너_이미지_2: 323012220, // 우측

    Position_닥터인포__메인____Body____로그인: 323020000,
    Position_닥터인포__메인____Body____마이페이지: 323030000,

    /// Position_닥터인포__메인____Body____약품정보: 323100000,
    Position_닥터인포__메인____Body____약품정보_컨텐츠목록: 323110000,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세: 323120000,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__탭_1: 323120100,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__탭_2: 323120200,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__탭_3: 323120300,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__HTML_방문신청: 323120410,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__HTML_샘플신청: 323120420,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__HTML_이메일답변신청: 323120430,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__HTML_기타: 323120490,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__메디컬트랜드배너: 323121100,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__댓글_등록: 323122101,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__댓글_수정: 323122102,
    Position_닥터인포__메인____Body____약품정보_컨텐츠상세__댓글_삭제: 323122103,

    /// Position_닥터인포__메인____Body____메디컬트렌드: 323200000,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠목록: 323210000,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세: 323220000,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세_컨텐츠링크: 323221000,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세__이벤트_이동: 323221001,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세__이벤트_참여: 323221002,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세__댓글_등록: 323222101, // 투표형 댓글 등록 가능
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세__댓글_수정: 323222102,
    Position_닥터인포__메인____Body____메디컬트렌드_컨텐츠상세__댓글_삭제: 323222103,

    /// Position_닥터인포__메인____Body____설문조사: 323300000,
    Position_닥터인포__메인____Body____설문조사_컨텐츠목록: 323310000,
    Position_닥터인포__메인____Body____설문조사_컨텐츠상세: 323320000,
    Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_임시저장: 323321001,
    Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_제출_비대상: 323321002,
    Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_제출_대상: 323321005,
    Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_보상: 323321009,
    Position_닥터인포__메인____Body____설문조사_컨텐츠상세__참여_삽입배너: 323321010,

    /// Position_닥터인포__메인____Body____웹세미나: 323500000,
    /// Position_닥터인포__메인____Body____웹세미나_제약웹세미나: 323510000,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠목록: 323511000,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠상세: 323512000,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠상세__My세미나_등록: 323512101,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠상세__My세미나_삭제: 323512102,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠상세__사전예약_등록: 323512201,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠상세__사전예약_취소: 323512202,
    Position_닥터인포__메인____Body____웹세미나_제약웹세미나_컨텐츠상세__웹세미나_시청: 323512301,
    /// Position_닥터인포__메인____Body____웹세미나_KMA연수교육: 323520000,
    Position_닥터인포__메인____Body____웹세미나_KMA연수교육_컨텐츠목록: 323521000,
    Position_닥터인포__메인____Body____웹세미나_KMA연수교육_컨텐츠상세: 323522000,
    /// Position_닥터인포__메인____Body____웹세미나_My세미나: 323530000,
    Position_닥터인포__메인____Body____웹세미나_My세미나_컨텐츠목록: 323531000,
    Position_닥터인포__메인____Body____웹세미나_My세미나_컨텐츠상세: 323532000,
    Position_닥터인포__메인____Body____웹세미나_My세미나_컨텐츠상세_제약웹세미나__My세미나_삭제: 323532102,
    Position_닥터인포__메인____Body____웹세미나_My세미나_컨텐츠상세_제약웹세미나__웹세미나_시청: 323532301,

    /// Position_닥터인포__메인____Body____공지사항: 323600000,
    Position_닥터인포__메인____Body____공지사항_컨텐츠목록: 323610000,
    Position_닥터인포__메인____Body____공지사항_컨텐츠상세: 323620000,
    Position_닥터인포__메인____Body____공지사항_컨텐츠상세_컨텐츠링크: 323621000,
    Position_닥터인포__메인____Body____공지사항_컨텐츠상세_댓글_등록: 323622101,
    Position_닥터인포__메인____Body____공지사항_컨텐츠상세_댓글_수정: 323622102,
    Position_닥터인포__메인____Body____공지사항_컨텐츠상세_댓글_삭제: 323622103,

    /// Position_닥터인포__메인____Body____이벤트: 323700000,
    Position_닥터인포__메인____Body____이벤트_컨텐츠목록: 323710000,
    Position_닥터인포__메인____Body____이벤트_컨텐츠상세: 323720000,
    Position_닥터인포__메인____Body____이벤트_컨텐츠상세_컨텐츠링크: 323721000,
    Position_닥터인포__메인____Body____이벤트_컨텐츠상세_댓글_등록: 323722101, // 투표형 댓글 등록 가능
    Position_닥터인포__메인____Body____이벤트_컨텐츠상세_댓글_수정: 323722102,
    Position_닥터인포__메인____Body____이벤트_컨텐츠상세_댓글_삭제: 323722103,
    Position_닥터인포__메인____Body____이벤트_참여_적립: 323723001,
    Position_닥터인포__메인____Body____이벤트_참여_보상: 323723002,

    /// Position_닥터인포__메인____Footer: 324000000,

    // #endregion Position_닥터인포__메인: 320000000

    /// Position_닥터인포__알림: 330000000
    // #region Position_닥터인포__알림: 330000000

    /// Position_닥터인포__알림_처방팝업: 331000000,
    Position_닥터인포__알림_처방팝업_새처방: 331100000, /// 노출 | 클릭_상세보기 | 클릭_다시보지않기
    Position_닥터인포__알림_처방팝업_재처방: 331200000, /// 노출 | 클릭_상세보기 | 클릭_다시보지않기

    Position_닥터인포__알림_스케줄팝업: 332000000, /// 노출 | 클릭_상세보기 | 클릭_다시보지않기

    Position_닥터인포__알림_시청알림팝업: 333000000,
    Position_닥터인포__알림_시청알림팝업__시청: 333100000, /// 웹세미나 시청팝업 - 단건 [외부링크] 시청링크 연결
    Position_닥터인포__알림_시청알림팝업__My세미나: 333200000, /// 웹세미나 시청팝업 - 다건 [닥터인포] My세미나 연결

    // #endregion Position_닥터인포__알림: 330000000

    // #endregion Position_닥터인포: 300000000

  },

  /// <summary>
  /// 분류 3 : 상태
  /// </summary>
  C: { // StatisticsNew_StateType
    // State_공통: 100000
    // #region State_공통: 100000

    State_공통__미분류: 100000, // 되도록 지양

    // #endregion State_공통: 100000

    // State_Action: 200000        // 시작 시 저장 (클릭)
    // #region State_Action: 200000

    // #region State_Action__클릭: 210000

    /// State_Action__클릭: 210000,
    State_Action__클릭_컨텐츠: 210100, // 진료실 라이브뉴스(라이브DI,고정슬롯) | 도구모음
    State_Action__클릭_상세보기: 210200, // 닥터인포 하단 알림팝업(처방,스케줄)
    State_Action__클릭_다시보지않기: 210300, // 닥터인포 하단 알림팝업(처방,스케줄)
    State_Action__클릭_이전: 210400, // 닥터인포 컨텐츠 글 이동(좌우버튼)
    State_Action__클릭_다음: 210500, // 닥터인포 컨텐츠 글 이동(좌우버튼)

    // #endregion State_Action__클릭: 210000

    // #region State_Action__자동유입: 220000

    /// State_Action__자동유입: 220000,            // 사용자 액션 없이 자동노출되는 경우 첫 클릭 수집 (ex. 일일팝업 메인 노출 후 첫번째 컨텐츠 클릭)
    State_Action__자동유입_컨텐츠: 220100, // 진료실 라이브뉴스(라이브DI,고정슬롯) | 도구모음
    State_Action__자동유입_상세보기: 220200, // 닥터인포 하단 알림팝업(처방,스케줄)
    State_Action__자동유입_다시보지않기: 220300, // 닥터인포 하단 알림팝업(처방,스케줄)
    State_Action__자동유입_이전: 220400, // 닥터인포 컨텐츠 글 이동(좌우버튼)
    State_Action__자동유입_다음: 220500, // 닥터인포 컨텐츠 글 이동(좌우버튼)

    // #endregion State_Action__자동유입: 220000

    // #endregion State_Action: 200000

    // State_Result: 300000        // 완료 시 저장 (설정조회, 노출)
    // #region State_Result: 300000

    /// State_Result__노출: 310000
    // #region State_Result__노출: 310000

    State_Result__노출: 310000,

    // #endregion State_Result__노출: 310000

    /// State_Result__Value: 320000
    // #region State_Result__Value: 320000

    /// State_Result__Value_Bit: 321000

    /// State_Result__Value_Bit_단일: 321100,   // Position_진료실__의사랑DB_환경설정
    State_Result__Value_Bit_단일__X: 321100, // OFF  | 실패
    State_Result__Value_Bit_단일__O: 321101, // ON   | 성공

    State_Result__Value_Bit_단일__클릭_결과__X: 321110, // 실패
    State_Result__Value_Bit_단일__클릭_결과__O: 321111, // 성공

    /// State_Result__Value_Bit_복합_약설라간: 321200,   // Position_진료실__의사랑DB_환경설정 : Globals.Instance.AllOptionStateEnum
    State_Result__Value_Bit_복합_약설라간__XXXX: 321200,
    State_Result__Value_Bit_복합_약설라간__XXXO: 321201,
    State_Result__Value_Bit_복합_약설라간__XXOX: 321202,
    State_Result__Value_Bit_복합_약설라간__XXOO: 321203,
    State_Result__Value_Bit_복합_약설라간__XOXX: 321204,
    State_Result__Value_Bit_복합_약설라간__XOXO: 321205,
    State_Result__Value_Bit_복합_약설라간__XOOX: 321206,
    State_Result__Value_Bit_복합_약설라간__XOOO: 321207,
    State_Result__Value_Bit_복합_약설라간__OXXX: 321208,
    State_Result__Value_Bit_복합_약설라간__OXXO: 321209,
    State_Result__Value_Bit_복합_약설라간__OXOX: 321210,
    State_Result__Value_Bit_복합_약설라간__OXOO: 321211,
    State_Result__Value_Bit_복합_약설라간__OOXX: 321212,
    State_Result__Value_Bit_복합_약설라간__OOXO: 321213,
    State_Result__Value_Bit_복합_약설라간__OOOX: 321214,
    State_Result__Value_Bit_복합_약설라간__OOOO: 321215,

    /// State_Result__Value_Int: 322100,   // Position_진료실__의사랑DB_처방정보
    State_Result__Value_Int_단일__미등록: 322101,
    State_Result__Value_Int_단일__기등록: 322102,
    State_Result__Value_Int_단일__의사랑등록: 322103,
    State_Result__Value_Int_단일__닥터인포등록: 322104,

    // #endregion State_Result__Value: 320000

    // #endregion State_Result: 300000

  },

}

// 빌드 시 숫자 값만 남도록 처리 (보안)
const GlobalEnums = {
  getEnumKey(enumObject, value) {
    return Object.entries(enumObject).reduce((result, [key, val]) => {
      if (result) return result // 이미 결과가 있으면 반환
      if (typeof val === 'object') {
        const nestedKey = this.getEnumKey(val, value)
        return nestedKey ? `${key}.${nestedKey}` : null
      }
      return val === value ? key : null
    }, null)
  }
}

export { SNT }
export default GlobalEnums
